import React from "react";
import styled from "styled-components";

const TableContainer = styled.div`
  overflow-x: auto;
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.$columns};
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 0.125rem solid #f8f9fa;
  align-items: center;
  text-align: left;
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
  transition: background-color 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  &:first-child {
    font-weight: 600;
    color: #555;
    border-bottom: 2px solid #e1e5e9;
    cursor: default;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 1rem;
    border-bottom: none;
  }

  &:not(:first-child):hover {
    background: ${(props) => (props.$clickable ? "#f8f9fa" : "inherit")};
  }
`;

const TableColumn = styled.div`
  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;

    &::before {
      content: attr(data-label);
      font-weight: 600;
      color: #555;
    }
  }

  ${TableRow}:first-child & {
    font-weight: 600;
  }

  ${(props) =>
    props.$rightAlign &&
    `
    &:last-child {
      text-align: right;
    }
  `}
`;

export const ActionsColumn = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const Table = ({ children, columns, ...props }) => (
  <TableContainer {...props}>
    {React.Children.map(children, (child) => {
      if (React.isValidElement(child) && child.type === Row) {
        return React.cloneElement(child, { $columns: columns });
      }
      return child;
    })}
  </TableContainer>
);

export const Row = ({ children, onClick, $columns, ...props }) => (
  <TableRow
    $columns={$columns}
    $clickable={!!onClick}
    onClick={onClick}
    {...props}
  >
    {children}
  </TableRow>
);

export const Column = ({ children, ...props }) => (
  <TableColumn {...props}>{children}</TableColumn>
);

export default Table;
